import React from "react";
import {Result, Typography} from "antd";

interface Props {
    extra?: React.ReactNode
}

const Error404 = ({extra}: Props) => {
    return (
        <Result
            status="404"
            title="404"
            subTitle={<p>Sorry, the page you visited does not exist. Please contact <Typography.Link href='mailto:rio@sfu.ca'>rio@sfu.ca</Typography.Link> for more information.</p>}
            extra={extra}
        />
    )
};

export default Error404;